var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validationErrors)?_c('div',{staticStyle:{"margin-bottom":"30px"}},[_c('ul',{staticClass:"vs-alert con-vs-alert-danger"},_vm._l((_vm.validationErrors),function(value,key,index){return _c('li',[_vm._v(_vm._s(value))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }